import React from 'react';

const NoFrame = ({ className }) => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 2H17V9.5" stroke="white" strokeWidth="3" strokeLinecap="round" />
            <path d="M9.5 17H2L2 9.5" stroke="white" strokeWidth="3" strokeLinecap="round" />
        </svg>
    )
}

export default NoFrame;